module.exports = __webpack_public_path__ + "img/iconNavb.5b3d97af.png";